export const colors = {
    primaryColor : '',
    secondaryColor :'',
    thirdColor : ''
}